import { Component } from 'preact';
import PropTypes from 'prop-types';

export class StepsProgress extends Component {
  stateClasses(step) {
    const { currentStep } = this.props;

    if (step < currentStep) {
      return 'steps-progess__item--done';
    }

    if (step === currentStep) {
      return 'steps-progess__item--current';
    }

    return null;
  }

  render() {
    const { currentStep } = this.props;

    return (
      <aside className="steps-progess">
        <div className={`steps-progess__item ${this.stateClasses(1)}`}>
          <div className="steps-progess__header">
            <div className="steps-progess__number">
              {currentStep > 1 ? (
                <i className="icon icon-check-mark-no-circle" />
              ) : (
                '1'
              )}
            </div>
            <b>Escolha o modelo</b>
          </div>

          {currentStep >= 2 ? (
            <div className="steps-progess__vehicle-info">
              <b>{this.props.modelName}</b>
              <div>{this.props.versionName}</div>
              <img src={this.props.image} height={140} alt="" />
            </div>
          ) : null}
        </div>
        <div className={`steps-progess__item ${this.stateClasses(2)}`}>
          <div className="steps-progess__header">
            <div className="steps-progess__number">
              {' '}
              {currentStep > 2 ? (
                <i className="icon icon-check-mark-no-circle" />
              ) : (
                '2'
              )}
            </div>
            <b>Escolha a unidade</b>
          </div>

          {currentStep >= 3 ? (
            <p className="steps-progess__unit-and-date-info">
              {this.props.unitName}
              <br />
              {this.props.preferredDate.split('-').reverse().join('/')} -{' '}
              {this.props.preferredTimeLabel.split('-')[1]}
            </p>
          ) : null}
        </div>
        <div className={`steps-progess__item ${this.stateClasses(3)}`}>
          <div className="steps-progess__header">
            <div className="steps-progess__number">
              {' '}
              {currentStep > 3 ? (
                <i className="icon icon-check-mark-no-circle" />
              ) : (
                '3'
              )}
            </div>
            <b>Dados pessoais</b>
          </div>
        </div>
      </aside>
    );
  }
}

StepsProgress.propTypes = {
  currentStep: PropTypes.number,
  modelName: PropTypes.string,
  versionName: PropTypes.string,
  image: PropTypes.string,
  unitName: PropTypes.string,
  preferredDate: PropTypes.string,
  preferredTimeLabel: PropTypes.string,
};
